import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { IAddToCartRequest } from "../../../Models/Package/IAddToCartRequest";
import { AxProdBookingInit } from "../Abstraction/AxBooking";
import { AxBooking } from "../Abstraction/AxBooking";
import { TimeSlotKeyDto } from "../../../Models/Reservation/TimeSlotKeyDto";

@ModuleName("AxPackBooking")
export class AxPackBooking extends AxBooking implements AxInit{
    constructor() { super(); }

    AxInit(initData: AxProdBookingInit): void {
        this.Init(initData);
    }

    AddToCart(): void {
        let requestObj: IAddToCartRequest = {
            Date: this.selectedDate,
            ProjNr: this.productSelection.ProjNr,
            PackTariffSheetNo: this.productSelection.ProductGroupIdentifier,
            PackageNr: this.productSelection.Id,
            PackagePositions: [],
            TimeSlotKeys: []
        };
        
        for (let timeSlot of this.selectedTimeSlots) {
            requestObj.TimeSlotKeys.push(new TimeSlotKeyDto(timeSlot.timeSlotKey));
        }

        for (let prod of this.productSelection.ProductList) {
            if (prod.Quantity > 0) {
                requestObj.PackagePositions.push({
                    PackSort: prod.Sort,
                    Quantity: prod.Quantity,
                    PackPos: prod.SubProductIdentifier
                });
            }
        }

        this._summaryRedirect.redirect(this.postURL, requestObj, true);
    }
}